export default "/images/ae1b4be72ea932b775dc9a1f6973c80f.avif";